"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var helpers_1 = require("../../../helpers");
var checkbox_1 = __importDefault(require("../../../../components/controls/checkbox"));
var input_1 = __importDefault(require("../../../../components/input"));
var popupResult_1 = __importDefault(require("../../../../components/popups/popupResult"));
var ST = __importStar(require("./styled"));
// @ts-ignore
var logo_telecom_center_svg_1 = __importDefault(require("../../../../assets/img/logo-telecom-center.svg"));
var baseButton_1 = require("../../../buttons/baseButton");
var phone = '+7 (495) 145-85-55';
var ENTER_KEY = 13;
var WRONG_AUTHDATA = 'Пожалуйста, проверьте правильность введенных данных: логина, пароля и города';
var INACTIVE_AGREEMENT = 'Договор не активен';
var errorText = react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(ST.Text, null, "1. \u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0432\u0432\u043E\u0434\u0430 \u043D\u043E\u043C\u0435\u0440\u0430 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430, \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u0434\u043E\u043F\u0443\u0449\u0435\u043D\u0430 \u043E\u0448\u0438\u0431\u043A\u0430"),
    react_1.default.createElement(ST.Text, null,
        "2. \u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0432\u0432\u043E\u0434\u0430 \u043F\u0430\u0440\u043E\u043B\u044F \u0438\u043B\u0438 \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 ",
        react_1.default.createElement(ST.StyledLink, { href: '/user/recovery/pass' }, "\u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C"),
        "."),
    react_1.default.createElement(ST.Text, null,
        "3. \u0412\u044B \u0440\u0430\u0441\u0442\u043E\u0440\u0433\u043B\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u043D\u0430 \u0443\u0441\u043B\u0443\u0433\u0438. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u0437\u0432\u043E\u043D\u0438\u0442\u0435 \u043D\u0430\u043C \u043F\u043E \u043D\u043E\u043C\u0435\u0440\u0443 ",
        react_1.default.createElement(ST.StyledLink, { href: "tel:".concat(phone) }, phone),
        "."));
var AuthFields = function (_a) {
    var buttonText = _a.buttonText, showCheckBox = _a.showCheckBox, sendEvent = _a.sendEvent, city = _a.city, authSubmit = _a.authSubmit, loginMessage = _a.loginMessage, showForgetLink = _a.showForgetLink;
    var _b = (0, react_1.useState)(''), login = _b[0], setLogin = _b[1];
    var _c = (0, react_1.useState)(''), password = _c[0], setPassword = _c[1];
    var _d = (0, react_1.useState)('Авторизоваться не удалось. Почему так может быть?'), errorTitle = _d[0], setErrorTitle = _d[1];
    var _e = (0, react_1.useState)(errorText), errorMessage = _e[0], setErrorMessage = _e[1];
    var _f = (0, react_1.useState)(true), rememberMe = _f[0], setRememberMe = _f[1];
    var _g = (0, react_1.useState)(false), showErrorPopup = _g[0], setShowErrorPopup = _g[1];
    var _h = (0, react_1.useState)(false), buttonDisabled = _h[0], setButtonDisabled = _h[1];
    var selectedCity = {
        value: city.domain,
        label: city.name
    };
    var loginRef = (0, react_1.useRef)();
    var passwordRef = (0, react_1.useRef)();
    (0, react_1.useEffect)(function () {
        if (!loginMessage)
            return;
        if (loginMessage === '') {
            setGAData('success');
        }
        else {
            setGAData('error');
            if (loginMessage === WRONG_AUTHDATA || loginMessage === INACTIVE_AGREEMENT) {
                setShowErrorPopup(true);
                if (loginMessage === INACTIVE_AGREEMENT) {
                    setErrorTitle('Произошла ошибка!');
                    setErrorMessage(react_1.default.createElement(ST.Text, null,
                        "\u0414\u0430\u043D\u043D\u044B\u0439 \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u043D\u0435 \u0430\u043A\u0442\u0438\u0432\u0435\u043D \u0438\u043B\u0438 \u0440\u0430\u0441\u0442\u043E\u0440\u0433\u043D\u0443\u0442. \u0414\u043B\u044F \u0440\u0435\u0448\u0435\u043D\u0438\u044F \u0432\u0430\u0448\u0435\u0433\u043E \u0432\u043E\u043F\u0440\u043E\u0441\u0430 \u043F\u043E\u0437\u0432\u043E\u043D\u0438\u0442\u0435 \u043D\u0430\u043C \u043F\u043E \u043D\u043E\u043C\u0435\u0440\u0443\u00A0",
                        react_1.default.createElement(ST.StyledLink, null,
                            react_1.default.createElement("a", { href: 'tel:+7(495)1458555' }, phone))));
                }
            }
        }
    }, [loginMessage]);
    var setCheckbox = function () {
        setRememberMe(function (prevState) { return !prevState; });
    };
    var deleteSpace = function (str) {
        return ((/\s/).test(str)) ? str.replace(/\s/g, '') : str;
    };
    var setGAData = function (text) {
        var GAData = {
            'event': 'UAevent',
            'category': 'authorization',
            'action': 'clicked login btn on _user_login page',
        };
        if (text) {
            (0, helpers_1.dataLayerPush)(__assign(__assign({}, GAData), { 'label': "".concat(text, " agreement authorization") }));
        }
        else {
            (0, helpers_1.dataLayerPush)(__assign(__assign({}, GAData), { 'label': 'agreement authorization' }));
        }
    };
    var validate = function () {
        var loginCurrent = loginRef === null || loginRef === void 0 ? void 0 : loginRef.current;
        var passwordCurrent = passwordRef === null || passwordRef === void 0 ? void 0 : passwordRef.current;
        if (login === '') {
            loginCurrent.setTouched(true);
        }
        if (password === '') {
            passwordCurrent.setTouched(true);
        }
        if (sendEvent) {
            sendEvent();
        }
        setGAData();
        // если все валидно и заполнено - сабмиттим
        if (!loginCurrent.state.hasError && !passwordCurrent.state.hasError && login !== '' && password !== '') {
            setButtonDisabled(true);
            authSubmit(deleteSpace(login), password, rememberMe, location.pathname, selectedCity.value);
        }
    };
    var enterPress = function (event) {
        if (event.which === ENTER_KEY) {
            validate();
        }
    };
    var closeResultPopup = function () {
        setShowErrorPopup(false);
        setButtonDisabled(false);
    };
    return (react_1.default.createElement(ST.Content, { onKeyDown: enterPress },
        react_1.default.createElement(ST.AuthHeader, null,
            react_1.default.createElement(ST.AuthTitle, null, "\u0410\u0432\u0442\u043E\u0440\u0438\u0437\u0430\u0446\u0438\u044F"),
            react_1.default.createElement(ST.Logo, { src: logo_telecom_center_svg_1.default })),
        react_1.default.createElement(input_1.default, { ref: loginRef, type: 'agreement', value: login, onChange: setLogin, placeholder: 'Номер договора или логин', errorMessage: 'Укажите ваш номер договора или логин', "data-test": 'auth-login-input', required: true, autoComplete: 'off' }),
        react_1.default.createElement(input_1.default, { key: 'password', ref: passwordRef, type: 'hidden', value: password, onChange: setPassword, placeholder: '\u041F\u0430\u0440\u043E\u043B\u044C', errorMessage: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u044C', "data-test": 'pass-enter-auth-data', required: true }),
        react_1.default.createElement(ST.LinksContainer, null,
            showCheckBox
                ? react_1.default.createElement(checkbox_1.default, { id: 'rememberMe', checked: rememberMe, onChange: setCheckbox, borderColor: '#dddddd', "data-test": 'checkbox-remember-me' }, "\u0417\u0430\u043F\u043E\u043C\u043D\u0438\u0442\u044C \u043C\u0435\u043D\u044F")
                : null,
            showForgetLink
                ? react_1.default.createElement(ST.LinkWrapper, null,
                    react_1.default.createElement(ST.StyledLink, { href: '/user/recovery/pass', isForgetLink: true }, "\u0417\u0430\u0431\u044B\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C?"))
                : null),
        react_1.default.createElement(baseButton_1.BaseButton, { block: true, text: buttonText || 'Далее', onClick: validate, disabled: buttonDisabled, "data-test": 'enter-btn' }),
        react_1.default.createElement(popupResult_1.default, { isOpen: showErrorPopup, onClose: closeResultPopup, title: errorTitle, text: errorMessage, type: 'error' })));
};
exports.default = AuthFields;
